const triggerNativeMessage = (method?: any, params?: any) => {
  try {
    if (typeof window !== 'undefined') {
      // Format parameters for iOS
      const iosParams = params ? Object.values(params).join('/') : '';

      // Android
      if ((window as any)?.androidApp?.[method]) {
        if (params) {
          (window as any).androidApp[method](...Object.values(params));
        } else {
          (window as any).androidApp[method]();
        }
      }
      // iOS
      if ((window as any)?.webkit?.messageHandlers?.iosApp) {
        (window as any).webkit.messageHandlers.iosApp.postMessage(
          params ? `${method}/${iosParams}` : method
        );
      }
    }
  } catch (error) {
    console.error('Error triggering native message:', error);
  }
};

export default triggerNativeMessage;
